/**
 * Matches already-absolute asset URLs (http/https, data URIs, blob URLs).
 */
const ABSOLUTE_PATH_REGEX = /^(?:https?:|data:|blob:)/i

/**
 * Derive base URL for API / asset resolution.
 * 1. Uses REACT_APP_API_BASE_URL env var if present (trailing slash removed).
 * 2. Falls back to window.location.origin in browser context.
 * 3. Returns empty string server-side or if origin unavailable.
 * @returns {string}
 */
function getBaseUrl() {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '')
  }

  if (typeof window !== 'undefined' && window.location) {
    return window.location.origin
  }

  return ''
}

/**
 * Resolve a potentially relative asset path to an absolute URL.
 * Preserves already-absolute (http/data/blob) paths, normalizes leading slash.
 * @param {string} path Raw asset path (relative or absolute).
 * @returns {string} Absolute or normalized path string.
 */
export function resolveAssetPath(path) {
  if (!path) {
    return ''
  }

  const trimmedPath = path.trim()

  if (ABSOLUTE_PATH_REGEX.test(trimmedPath)) {
    return trimmedPath
  }

  const normalized = trimmedPath.startsWith('/')
    ? trimmedPath
    : `/${trimmedPath}`
  const baseUrl = getBaseUrl()

  return baseUrl ? `${baseUrl}${normalized}` : normalized
}
